function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "32px",
    width: "33px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CB7E8"
    },
    d: "M496.327,109.715c-43.212,0-78.367,35.156-78.367,78.367v83.592c0,8.655,7.018,15.673,15.673,15.673 h47.02v99.265c0,8.655,7.018,15.673,15.673,15.673c8.656,0,15.673-7.019,15.673-15.673V125.388 C512,116.732,504.982,109.715,496.327,109.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CB7E8"
    },
    d: "M78.367,109.713c-8.656,0-15.673,7.018-15.673,15.675v62.687c0,8.647-7.031,15.682-15.673,15.682 s-15.673-7.034-15.673-15.68v-62.689c0-8.656-7.018-15.675-15.673-15.675S0,116.732,0,125.388v62.689 c0,20.435,13.104,37.859,31.347,44.33v154.206c0,8.655,7.018,15.673,15.673,15.673s15.673-7.019,15.673-15.673V232.405 c18.243-6.471,31.347-23.896,31.347-44.332v-62.686C94.041,116.732,87.023,109.713,78.367,109.713z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E5F6"
    },
    d: "M250.775,120.163c-74.901,0-135.837,60.936-135.837,135.838c0,74.9,60.935,135.837,135.837,135.837 s135.837-60.936,135.837-135.837C386.612,181.1,325.677,120.163,250.775,120.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCD6F2"
    },
    d: "M250.775,120.163v271.673c74.901,0,135.837-60.936,135.837-135.837S325.677,120.163,250.775,120.163z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CB7E8"
    },
    d: "M250.775,329.143c-40.332,0-73.143-32.811-73.143-73.143c0-40.331,32.811-73.143,73.143-73.143 s73.143,32.812,73.143,73.143S291.108,329.143,250.775,329.143z M250.775,214.203c-23.046,0-41.796,18.75-41.796,41.796 c0,23.047,18.75,41.796,41.796,41.796s41.796-18.749,41.796-41.796C292.571,232.954,273.822,214.203,250.775,214.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6398DE"
    },
    d: "M250.775,182.858v31.347c23.046,0,41.796,18.749,41.796,41.796c0,23.046-18.75,41.796-41.796,41.796 v31.347c40.332,0,73.143-32.812,73.143-73.143C323.918,215.669,291.108,182.858,250.775,182.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6398DE"
    },
    d: "M78.367,109.713c-8.656,0-15.673,7.018-15.673,15.675v62.687c0,8.647-7.031,15.682-15.673,15.682 v198.531c8.656,0,15.673-7.019,15.673-15.673V232.405c18.243-6.471,31.347-23.896,31.347-44.332v-62.686 C94.041,116.732,87.023,109.713,78.367,109.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6398DE"
    },
    d: "M496.327,109.715c-5.367,0-10.608,0.544-15.673,1.577v176.055v99.265 c0,8.655,7.018,15.673,15.673,15.673c8.656,0,15.673-7.019,15.673-15.673V125.388C512,116.732,504.982,109.715,496.327,109.715z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.6687d32a043067c520a42105eff5ba2c.svg";
export { ForwardRef as ReactComponent };